import React from 'react';
import { convertNumberToTime, getRepeatTime } from './helpers';
import { getFeature, getVideoMetadataValue } from '../../../../tools/utils';

class WorkoutOverlay extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            restTimer: getVideoMetadataValue(props.video, 'restTimer', 60)
        }
        this.defaultRestTimer = getVideoMetadataValue(props.video, 'restTimer', 60)
    }

    componentDidUpdate(prevProps, prevState){
        const { curStage, playNextCircuit, video } = this.props;
        if(curStage !== prevProps.curStage){
            if(curStage === 'workout_end') {
                this.timer = setInterval(()=>{
                    let curRestTime = this.state.restTimer - 1;
                    if(curRestTime >= 0){
                        if(window.document.getElementsByClassName('workout-overlay-player').length === 0) {
                            clearInterval(this.timer);
                        } else {
                            this.setState({restTimer: curRestTime});
                        }
                    } else {
                        this.setState({restTimer: this.defaultRestTimer}, ()=>{
                            clearInterval(this.timer);
                            playNextCircuit(video);
                        })
                    }
                }, 1000)
            } else if(curStage === 'workout_start'){
                this.setState({restTimer: this.defaultRestTimer}, ()=>{
                    clearInterval(this.timer);
                })
            }
        }
    }

    render(){
        const { curStage, stageChangeHandler, video, playNextCircuit, metadataMap } =  this.props;
        const { title, description } = video.gist;
        const {
            startWorkoutCTA,
            replayVideoCTA,
            backToVideoCTA,
            restCTA,
            restHeader,
            restMessage,
            repeatCircuitCTA,
            nextCircuitCTA,
            repeatLabel,
            timesLabel
        } = metadataMap;

        return <div className="workout-overlay">
            {curStage === 'circuit_end' && <div className="circuit-end upper-layer">
                <div className="btn-group">
                    <button className="start-workout" onClick={() => stageChangeHandler('workout_start')}>{startWorkoutCTA}</button>
                    <button onClick={() => stageChangeHandler('circuit_start')}>{replayVideoCTA}</button>
                </div>
            </div>}
            {curStage === 'workout_start' && <div className="workout-start upper-layer">
                <div className="workout-left flex-clm-center">
                    <div className="episode-details">
                        <h1>{title}</h1>
                        <p>{description}</p>
                    </div>
                </div>
                <div className="workout-right flex-clm-center">
                    <div className="btn-group">
                        <button className="btn-up" onClick={() => stageChangeHandler('circuit_start')}>{backToVideoCTA}</button>
                        <button className="btn-down" onClick={() => stageChangeHandler('workout_end')}>{restCTA}</button>
                    </div>
                </div>
            </div>}
            {curStage === 'workout_end' && <div className="workout-end upper-layer">
                <div className="workout-left flex-clm-center">
                    <div className="rest-details">
                        <div className="rest-details-up">
                            <h1>{restHeader}</h1>
                            <p>{restMessage}</p>
                        </div>
                        <div className="rest-details-down flex-clm-center">
                            <div className="rest-timer">{convertNumberToTime(this.state.restTimer)}</div>
                        </div>
                    </div>
                </div>
                <div className="workout-right flex-clm-center">
                    <p>{getRepeatTime(video, repeatLabel, timesLabel)}</p>
                    <div className="btn-group">
                        <button className="btn-up" onClick={() => stageChangeHandler('circuit_start')}>{repeatCircuitCTA}</button>
                        <button className="btn-down" onClick={() => playNextCircuit(video)}>{nextCircuitCTA}</button>
                    </div>
                </div>
            </div>}
            {<div className="blur-overlay"></div>}
        </div>
    }
}

export default WorkoutOverlay;